module.exports = __webpack_public_path__ + "static/media/icon-kebab-sg.a2bb3625.svg";